export class WorkOrder {
    id: number;
    type: string;
    piece_id: number;
    data: object = {};
    fiche_intervention_id: number;

    public constructor(init?: Partial<WorkOrder>) {
        Object.assign(this, init);
    }
}
